import api from 'ApiConfig';

const studentAssignmentServices = {
  assignStudentToCompany: async (formData) => {
    return api.post('/student-assignment/assign', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getAllAssignments: async (params = {}) => {
    return api.get('/student-assignment/all', { params });
  },
  getOngoingInterviews: async (params = {}) => {
    return api.get('/student-assignment/ongoing-interviews', { params });
  },
  endInterviewProcess: async (data) => {
    return api.post('/student-assignment/ongoing-interviews/end', data);
  },
  reopenInterviewProcess: async (data) => {
    return api.post('/student-assignment/ongoing-interviews/reopen', data);
  },
  getStudentsForAssignment: async () => {
    return api.get('/student-assignment/students-for-assignment');
  },
  getAllActiveStudents: async () => {
    return api.get('/student-assignment/all-students');
  },
  getStudentAssignments: async (studentId) => {
    return api.get(`/student-assignment/student/${studentId}`);
  },
  getCompanyAssignments: async (companyId) => {
    return api.get(`/student-assignment/company/${companyId}`);
  },
  updateAssignmentStatus: async (id, data) => {
    return api.put(`/student-assignment/${id}/status`, data);
  },
  editAssignment: async (id, formData) => {
    return api.put(`/student-assignment/${id}/edit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteAssignment: async (id) => {
    return api.delete(`/student-assignment/${id}`);
  },
  getStudentResumeInfo: async (studentId) => {
    return api.get(`/placement/student-resume/${studentId}`);
  },
  getStudentStaffNotes: async (studentId) => {
    return api.get(`/placement/student-staff-notes/${studentId}`);
  },
  downloadResumes: async (studentIds) => {
    return api.post(
      '/student-assignment/download-resumes',
      { studentIds },
      { responseType: 'blob' }
    );
  },
};

export default studentAssignmentServices;
